/* Biolash side cart boosters — urgentie- en levering-aftellers.
   Bewust framework-loos: queryt elke tick opnieuw zodat ge-morphte
   drawer-content (na cart-updates) automatisch blijft updaten. */
(function () {
  if (window.__biolashCartBoosters) return;
  window.__biolashCartBoosters = true;

  var RESERVE_KEY = 'biolash_cart_reserve_until';

  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function reserveDeadline(minutes) {
    var now = Date.now();
    var stored = parseInt(sessionStorage.getItem(RESERVE_KEY) || '0', 10);
    if (!stored || stored <= now) {
      stored = now + minutes * 60 * 1000;
      sessionStorage.setItem(RESERVE_KEY, String(stored));
    }
    return stored;
  }

  function tick() {
    var now = Date.now();

    // Urgentie reserveringstimer (m:ss)
    var urgencyEls = document.querySelectorAll('[data-biolash-urgency]');
    for (var i = 0; i < urgencyEls.length; i++) {
      var el = urgencyEls[i];
      var minutes = parseInt(el.getAttribute('data-biolash-urgency'), 10) || 10;
      var deadline = reserveDeadline(minutes);
      var diff = Math.max(0, deadline - now);
      var totalSec = Math.floor(diff / 1000);
      el.textContent = Math.floor(totalSec / 60) + ':' + pad(totalSec % 60);
      if (diff <= 0) sessionStorage.removeItem(RESERVE_KEY);
    }

    // Levering cutoff-aftelling (Hu MMm SSs tot eerstvolgende cutoff)
    var countdownEls = document.querySelectorAll('[data-biolash-countdown]');
    for (var j = 0; j < countdownEls.length; j++) {
      var c = countdownEls[j];
      var h = parseInt(c.getAttribute('data-hour'), 10);
      var mi = parseInt(c.getAttribute('data-minute'), 10) || 0;
      if (isNaN(h)) continue;
      var target = new Date();
      target.setHours(h, mi, 0, 0);
      if (target.getTime() <= now) target.setDate(target.getDate() + 1);
      var d = Math.floor((target.getTime() - now) / 1000);
      c.textContent = Math.floor(d / 3600) + 'u ' + pad(Math.floor((d % 3600) / 60)) + 'm ' + pad(d % 60) + 's';
    }
  }

  tick();
  setInterval(tick, 1000);
})();
